import { Box, IconButton, Modal, Table, TableCell, TableRow, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import DOMPurify from 'dompurify';
import '../Reports/Reports.css';


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    padding: "20px !important",
    bgcolor: "background.paper",
    //border: "1px solid #dfe3e8",
    borderRadius:"5px",
    boxShadow: 24,
    maxHeight: "80%",
    overflowY: "auto",
    bottom:"auto"
  };

export default function AuditDataCompareModal(props) {
  
  const oldValues= props.rowData.oldValues? JSON.parse(props.rowData.oldValues):"";
  const newValues= props.rowData.newValues? JSON.parse(props.rowData.newValues):"";

  const formatJSON= (obj)=>{
    const filteredObj=Object.fromEntries(
      Object.entries(obj).filter(([key, value])=>value!=="")
    );
    if(Object.keys(filteredObj).length===0){
      return '';
    }
    //return JSON.stringify(filteredObj, null, 2);
    return Object.entries(filteredObj).map(([key, value])=> `"${key}": "${value}"`).join(',\n');

  }  

  const highlightDifferences=(oldObj, newObj)=>{
    let oldResult='';
    let newResult='';
    let oldUpdateValues='';
    let newUpdateValues='';
    let showBenefitType= true;


    if(props.rowData.action === "UPDATE" || props.rowData.action === "DELETE"){
    const keys = Object.keys(oldObj); 
    const newObjKeys = Object.keys(newObj);

    newObjKeys.forEach(key=>{
      if(key === "One Time Allowance Update"){
        showBenefitType = false;
      }
    })
    keys.forEach(key =>{
      const oldValue = oldObj[key];
      const newValue = newObj[key];
      const isDifferent = oldValue!== newValue;

      if(props.type==="USER_ENROLLMENT_LOGS"){ //&& props.rowData.action !== "DELETE"
        //const displayOldValue = key === "SSN" && !showSSN && isDifferent? maskSSN(oldValue): oldValue;
        //const displayNewValue = key === "SSN" && !showSSN && isDifferent? maskSSN(newValue): newValue;
        if(isDifferent || key === "Payee LastName" || key=== "Payee FirstName" || (key === "Benefit Type" && showBenefitType)){
            
            //oldResult += `<span onmouseover="(${handleMouseOver})" onmouseleave="(${handleMouseLeave})">"${key}": "${displayOldValue}"</span>\n`;
            //newResult += `<span onmouseover="(${handleMouseOver})" onmouseleave="(${handleMouseLeave})">"${key}": "${displayNewValue}"</span>\n`;
            oldResult += isDifferent ?
            `<span style="font-weight:800">"${key}": "${oldValue}"</span>\n` : 
            `<span>"${key}": "${oldValue}"</span>\n`;
            newResult += isDifferent ?
            `<span style="font-weight:800">"${key}": "${newValue}"</span>\n` :
            `<span>"${key}": "${newValue}"</span>\n`;
        }
      }
      /*else if(props.type==="USER_ENROLLMENT_LOGS" && props.rowData.action === "DELETE"){
        oldResult = formatJSON(oldObj);
        newResult = formatJSON(newObj);
      }*/
      else{
        oldResult += isDifferent?
        `<span style="font-weight:800">"${key}": "${oldValue}"</span>\n` : `"${key}": "${oldValue}"\n`;
        newResult += isDifferent? 
        `<span style="font-weight:800">"${key}": "${newValue}"</span>\n` : `"${key}": "${newValue}"\n`;
      }
    })  
      oldUpdateValues = oldResult.trim().replace(/,$/, '');
      newUpdateValues = newResult.trim().replace(/,$/, '');
      
  }else{
      oldResult = formatJSON(oldObj);
      newResult = formatJSON(newObj);
  }

    oldResult = DOMPurify.sanitize(oldResult);
    newResult = DOMPurify.sanitize(newResult);
    oldUpdateValues = DOMPurify.sanitize(oldUpdateValues);
    newUpdateValues = DOMPurify.sanitize(newUpdateValues);

    return {oldResult, newResult, oldUpdateValues, newUpdateValues};
  }

  const {oldResult, newResult, oldUpdateValues, newUpdateValues} = highlightDifferences(oldValues, newValues);

    return (
    <div>
    <Modal
      open={props.open}
      onClose={props.plzclose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modalstyle"
    >
      <Box sx={style}>
        
        <div>
        <Typography id="modal-modal-title" className="enroll-audit-mdl-typography">
       
          <Table className="enroll-audit-table">
            <TableRow className="enroll-audit-modal-tblRow">
              <TableCell style={{whiteSpace:"nowrap", width:"25px", height:"auto" ,padding:"0px", margin:"0px", fontWeight:"110px", fontSize:"16px", border:"none"}}>
              <p><b>Action</b>{" - "+props.rowData.action}</p>
              </TableCell>
              <TableCell style={{whiteSpace:"nowrap", width:"25px", height:"auto",padding:"0px", margin:"0px", fontWeight:"110px", fontSize:"16px", border:"none"}}>
              <p><b>Date</b>{" - "+props.rowData.updatedAt}</p>
              </TableCell>              
            </TableRow>
            <TableRow>
              <TableCell colSpan={2} style={{whiteSpace:"nowrap", width:"1px", height:"auto",padding:"0px", margin:"0px", fontWeight:"110px", fontSize:"16px", border:"none"}}>
              <p><b>User Name</b>{" - "+props.rowData.updatedBY}</p>
              </TableCell> 
            </TableRow>
          </Table>
          </Typography> 
          
          <div style={{paddingTop:"2px", backgroundColor:"#FFFFFF"}}>
          <IconButton
            aria-label="close"
            onClick={props.plzclose}
            sx={{
              position: "absolute",
              right: 40,
              top: 40,
              color: "white",
              backgroundColor: "#002d82",
              padding: "2px",
            }}
          >
            <CloseIcon />
          </IconButton>
          </div>
          </div>
        <br></br>
        
        <div className="enroll-audit-div1">
          <div className="enroll-audit-div2">
            <h3>Old Values</h3>
            <pre className="enroll-audit-pre">
              {/* <div>{`{\n${oldResult}}`}</div> */}
              {oldUpdateValues ?
                <div dangerouslySetInnerHTML={{__html: oldUpdateValues }}/>
                : <div dangerouslySetInnerHTML={{__html: oldResult }}/>
              }
              
            </pre>
          </div>
          <div className="enroll-audit-div2">
            <h3>New Values</h3>
            <pre className="enroll-audit-pre">
              {/* <div>{`{\n${newResult}}`}</div> */}
              {newUpdateValues ?
                <div dangerouslySetInnerHTML={{__html: newUpdateValues }}/>
                : <div dangerouslySetInnerHTML={{__html: newResult }}/>
              }
              
            </pre>
          </div>
        </div>
      </Box>
    </Modal>
  </div>
    )
}
